export default {
  time: {
    hhmmss: {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    },
  },
  date: {
    hhmmss: {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    },
  },
  number: {
    compact: { notation: 'compact' },
    temperature: {
      minimumFractionDigits: 1,
      style: 'unit',
      unit: 'celsius',
    },
    kg: {
      style: 'unit',
      unit: 'kilogram',
    },
    percent: {
      maximumFractionDigits: 0,
      style: 'unit',
      unit: 'percent',
    },
    EUR: {
      style: 'currency',
      currency: 'EUR',
    },
    USD: {
      style: 'currency',
      currency: 'USD',
    },
  },
};
